import { DAY_IN_MS, HOUR_IN_MS, MIN_IN_MS, SEC_IN_MS } from '../../utils/time';
import bondingCurveCfgs from '../powerups/airtable/offchainTradingBondingCurve';
import Big from 'big.js';

const [bondingCurveCfg] = bondingCurveCfgs;

export const REPLICANT_UPLOAD_LENGTH_LIMIT = 940000;

export const offchainTokenSearchCount = 10;
export const offchainTradingNotifDelay = 2000;

export const offchainTokenDisplayMultiplier = 1_000_000;

export const curveConfig = {
  exponent: Big(bondingCurveCfg.exponent),
  startPrice: Big(bondingCurveCfg.initial_price),
  stepSize: Big(bondingCurveCfg.step_size),
  microModifier: Big(0.000000001),
};

export const txConfig = {
  fee: 0.01, // 1%
  sellModifier: Big(bondingCurveCfg.sell_multiplier), // -0%,
  buyModifier: Big(bondingCurveCfg.buy_multiplier), // +0%,
  defaultMaxSlippage: Big(1.02), // 2%,
  clientSlippage: 1.001, // 0.1%
};

export const maxTxCount = 700;
export const maxTokenAllTimeSliceCount = 500;
export const maxPortfolioAllTimeSliceCount = 500;

export const fixedSliceTimeWindows = ['hour24', 'day7', 'day30'] as const;

export type FixedSliceTimeWindows = (typeof fixedSliceTimeWindows)[number];
export type SliceTimeWindows = FixedSliceTimeWindows | 'allTime';

export interface SliceConfig {
  windowId: SliceTimeWindows;
  interval: number;
  window: number;
}

export const tokenPriceSliceConfigs: Record<
  FixedSliceTimeWindows,
  SliceConfig
> = {
  hour24: {
    windowId: 'hour24',
    interval: 5 * MIN_IN_MS, // 288 intervals for 1 day
    window: 1 * DAY_IN_MS,
  },
  day7: {
    windowId: 'day7',
    interval: 30 * MIN_IN_MS, // 336 intervals for 7 days
    window: 7 * DAY_IN_MS,
  },
  day30: {
    windowId: 'day30',
    interval: 120 * MIN_IN_MS, // 360 intervals for 30 days
    window: 30 * DAY_IN_MS,
  },
};

export const portfolioPriceSliceConfigs: Record<
  FixedSliceTimeWindows,
  SliceConfig
> = {
  hour24: {
    windowId: 'hour24',
    interval: 30 * MIN_IN_MS, // 48 intervals for 1 day
    window: 1 * DAY_IN_MS,
  },
  day7: {
    windowId: 'day7',
    interval: 3 * HOUR_IN_MS, // 56 intervals for 7 days
    window: 7 * DAY_IN_MS,
  },
  day30: {
    windowId: 'day30',
    interval: 12 * HOUR_IN_MS, // 60 intervals for 30 days
    window: 30 * DAY_IN_MS,
  },
};

export const shortestPortofolioUpdateInterval =
  portfolioPriceSliceConfigs.hour24.interval;
export const longestPortofolioUpdateInterval =
  portfolioPriceSliceConfigs.day30.window;

export const RESET_SEASON_2_LABEL = 'RESET_SEASON_2_LABEL';

export const season2StartTime = 1724994000839; // Fri Aug 30 2024 14:00:00 GMT+0900 (Japan Standard Time)

export const failedTxLifespan = MIN_IN_MS;
export const txVerificationTimeout = 10 * SEC_IN_MS;

export const DEFAULT_FLAGGED_IMAGE =
  'https://notgemz.cms.gemz.fun/media/flagged.png';

export const maxFollowingCount = 200;
